import { ActivityDTO, ActivityStatus } from 'src/types/dto/activity.dto';

/** Booking-request pipeline (86cact7wn) — unallocate/cancel blocked; pre_scheduled excluded. */
export const BOOKING_REQUEST_PIPELINE_STATUSES = new Set<ActivityStatus>([
  ActivityStatus.PRE_REQUESTED,
  ActivityStatus.PRE_ACCEPTED,
  ActivityStatus.REQUESTED,
  ActivityStatus.ACCEPTED,
]);

const SCHEDULE_CALENDAR_BLOCKED_STATUSES = new Set<ActivityStatus>([
  ActivityStatus.PRE_REQUESTED,
  ActivityStatus.PRE_ACCEPTED,
  ActivityStatus.REQUESTED,
  ActivityStatus.COMPLETED,
]);

export function isBookingRequestBlockingScheduleModification(
  activity?: Pick<ActivityDTO, 'bookingRequestInProgress'> | null,
): boolean {
  return Boolean(activity?.bookingRequestInProgress);
}

export function isActivityInBookingRequestPipeline(
  activity?: Pick<ActivityDTO, 'status'> | null,
): boolean {
  return Boolean(activity && BOOKING_REQUEST_PIPELINE_STATUSES.has(activity.status));
}

export function isActivityStatusBlockingUnallocate(
  activity?: Pick<ActivityDTO, 'status'> | null,
): boolean {
  return isActivityInBookingRequestPipeline(activity);
}

export function isActivityStatusBlockingScheduleModification(
  activity?: Pick<ActivityDTO, 'status'> | null,
): boolean {
  return Boolean(activity && SCHEDULE_CALENDAR_BLOCKED_STATUSES.has(activity.status));
}

export function isScheduleModificationBlocked(
  activity?: Pick<ActivityDTO, 'status' | 'bookingRequestInProgress'> | null,
): boolean {
  if (!activity) {
    return false;
  }
  return (
    isBookingRequestBlockingScheduleModification(activity) ||
    isActivityStatusBlockingScheduleModification(activity)
  );
}

/** Manual cancel-to-cancelled (not "cancel booking request"). */
export function isManualActivityCancellationBlocked(
  activity?: Pick<ActivityDTO, 'status' | 'bookingRequestInProgress'> | null,
): boolean {
  if (!activity) {
    return false;
  }
  return (
    isBookingRequestBlockingScheduleModification(activity) ||
    isActivityInBookingRequestPipeline(activity)
  );
}
